import { createAction } from 'redux-act';
/* Create Feedback Team action */
const createFeedbackTeamRequest = createAction('CREATE_FEEDBACK_TEAM_REQUEST', data => data);
const createFeedbackTeamSuccess = createAction('CREATE_FEEDBACK_TEAM_SUCCESS', data => data);
const createFeedbackTeamError = createAction('CREATE_FEEDBACK_TEAM_ERROR');

/* Get All Feedback Teams action */
const getAllFeedbackTeamsRequest = createAction('GET_ALL_FEEDBACK_TEAMS_REQUEST', data => data);
const getAllFeedbackTeamsSuccess = createAction('GET_ALL_FEEDBACK_TEAMS_SUCCESS', data => data);
const getAllFeedbackTeamsError = createAction('GET_ALL_FEEDBACK_TEAMS_ERROR');

/* Create Feedback list */
const createFeedbackRequest = createAction('CREATE_FEEDBACK_REQUEST', data => data);
const createFeedbackSuccess = createAction('CREATE_FEEDBACK_SUCCESS', data => data);
const createFeedbackError = createAction('CREATE_FEEDBACK_ERROR');

/* Given Feedback action */
const givenFeedbackRequest = createAction('GIVEN_FEEDBACK_REQUEST', data => data);
const givenFeedbackSuccess = createAction('GIVEN_FEEDBACK_SUCCESS', data => data);
const givenFeedbackError = createAction('GIVEN_FEEDBACK_ERROR');

/* get Received Feedback On Filter action */
const getReceivedFeedbackOnFilterRequest = createAction('GET_RECEIVED_FEEDBACK_ON_FILTER_REQUEST', data => data);
const getReceivedFeedbackOnFilterSuccess = createAction('GET_RECEIVED_FEEDBACK_ON_FILTER_SUCCESS', data => data);
const getReceivedFeedbackOnFilterError = createAction('GET_RECEIVED_FEEDBACK_ON_FILTER_ERROR');

/* Get Feedback Dashboard Data action */
const getFeedbackDashboardDataRequest = createAction('GET_FEEDBACK_DASHBOARD_DATA_REQUEST', data => data);
const getFeedbackDashboardDataSuccess = createAction('GET_FEEDBACK_DASHBOARD_DATA_SUCCESS', data => data);
const getFeedbackDashboardDataError = createAction('GET_FEEDBACK_DASHBOARD_DATA_ERROR');

/* clear existing Feedback action */
const handleClearFeedbackStore = createAction('HANDLE_CLEAR_FEEDBACK_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    createFeedbackTeamRequest,
    createFeedbackTeamSuccess,
    createFeedbackTeamError,

    getAllFeedbackTeamsRequest,
    getAllFeedbackTeamsSuccess,
    getAllFeedbackTeamsError,

    createFeedbackRequest,
    createFeedbackSuccess,
    createFeedbackError,

    givenFeedbackRequest,
    givenFeedbackSuccess,
    givenFeedbackError,

    getReceivedFeedbackOnFilterRequest,
    getReceivedFeedbackOnFilterSuccess,
    getReceivedFeedbackOnFilterError,

    getFeedbackDashboardDataRequest,
    getFeedbackDashboardDataSuccess,
    getFeedbackDashboardDataError,
    
    handleClearFeedbackStore,
    // toastMsgAction,
    
}